export const images = {
  loginBg: require('../assets/images/login-bg.png'),
  profile: require('../assets/images/profile.png'),
  Empty: require('../assets/images/empty.png'),
}
